<template>
    <div class="notice-panel">
        <custom-panel :title="title" :height="height" @moreClick="moreClickHandle">
            <template #content>
                <a-spin :spinning="loading" v-if="noticeList.length > 0">
                    <div
                        v-for="item in noticeList"
                        :key="item.id"
                        class="notice-item"
                        @click="noticeDetailHandle(item)"
                    >
                        <div class="notice-title">{{ item.title }}</div>
                        <div class="notice-time">{{ item.createdtime?.substring(0, 10) }}</div>
                    </div>
                </a-spin>
                <a-empty style="margin-top: 40px" v-else />
            </template>
        </custom-panel>

        <a-modal
            v-model="modalVisible"
            title="通知公告详情"
            :width="960"
            :footer="null"
            :mask-closable="false"
            :keyboard="false"
        >
            <div v-if="noticeDetail" class="modal-notice-detail">
                <div class="modal-notice-title">{{ noticeDetail.title }}</div>
                <div class="modal-notice-time">{{ noticeDetail.createdtime?.substring(0, 10) }}</div>
                <div class="modal-notice-content" v-html="noticeDetail.content"></div>
                <div class="modal-notice-file-list" v-if="fileList.length">
                    <div>附件：</div>
                    <div class="list-item" v-for="(item, i) in fileList" :key="item.id">
                        <span>{{ i + 1 }}、</span>
                        <div class="title" @click="downloadFile(item)">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { getNoticeData } from '../../../common/api';
import CustomPanel from '@/components/custom-panel.vue';
import axios from 'axios';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel
    },

    data() {
        return {
            title: '通知公告',
            noticeList: [],
            noticeDetail: {},
            modalVisible: false,
            fileList: [],
            loading: false
        };
    },

    methods: {
        moreClickHandle() {
            this.$router.push('/notification');
        },

        async getNoticeList() {
            this.loading = true;
            const { data } = await getNoticeData({
                n: 1,
                s: 6,
                f: { infoCategory_SEQ: 'notice', status_SEQ: 'normal' }
            });
            this.noticeList = data.rows;
            this.loading = false;
        },

        noticeDetailHandle(item) {
            this.fileList = [];
            this.noticeDetail = {};
            this.noticeDetail = item;
            this.fileList = JSON.parse(item.attachment);
            this.modalVisible = true;
        },

        async downloadFile(file) {
            this.downloadByBlob(file.downloadUrl, file.name);
        },

        downloadByBlob(url, fileName) {
            const pathArr = url?.split('/') ?? [];
            axios.get(url, { responseType: 'blob' }).then(res => {
                const blob = new Blob([res.data]);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName || pathArr[pathArr.length - 1] || true;
                link.click();
                URL.revokeObjectURL(link.href);
            });
        }
    },

    created() {
        this.getNoticeList();
    }
};
</script>

<style lang="scss" scoped>
.notice-panel {
    .notice-item {
        height: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
            background: #f0f4fb;
        }

        .notice-title {
            width: calc(100% - 96px);
            padding-left: 20px;
            font-size: 16px;
            color: #333333;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &::before {
                position: absolute;
                left: 0;
                top: 2px;
                content: '';
                width: 16px;
                height: 16px;
                margin-right: 4px;
                background: url(../imgs/icon-sound.svg) no-repeat center center / contain;
                transform: translateY(2px);
            }
        }

        .notice-time {
            width: 96px;
            margin-left: auto;
            font-size: 14px;
            color: #999999;
            text-align: right;
        }
    }
}

.modal-notice-detail {
    height: 64vh;
    overflow: auto;

    .modal-notice-title {
        font-size: 18px;
        font-weight: 600;
        text-align: center;
    }

    .modal-notice-time {
        margin-bottom: 4px;
        font-size: 14px;
        color: #999999;
        text-align: center;
    }

    .modal-notice-content {
        padding-top: 20px;
        border-top: 1px solid #f1f1f1;
        font-size: 16px;
        color: #333333;
        line-height: 1.5;
        text-align: justify;
    }

    .modal-notice-file-list {
        margin-top: 50px;
        font-size: 14px;

        .list-item {
            display: flex;
            align-items: center;
            height: 30px;
            line-height: 30px;
            .title {
                color: #007fff;
                cursor: pointer;
            }
        }
    }
}
</style>
